<template>
  <div class="body">
    <!--------- first-section ------->
    <div class="container">
      <!-- <div v-if="this.$store.state.counter === 1 "> -->
      <div class="first-section">
        <div id="activity-block">
          <div class="block__title_first" id="activity-title">
            <h3>Activity Statistical Overview</h3>
            <select
              class="viewDate"
              @change="handleActivityTimeSelection"
              v-model="dataTime"
              name="time"
            >
              <option value="total">total</option>
              <option value="week">past week</option>
              <option value="month">past month</option>
              <option value="year">past year</option>
            </select>
          </div>
          <div class="box" id="activity-box">
            <div class="box-header" id="activity-header">
              <div id="activity-label1">
                <h4>Number of games played</h4>
                <br />
                <p>All users activity on the court</p>
                <br />
                <output>{{ getBookingsOverview.count }}</output> <br />
                <br />
              </div>
              <div id="activity-label2">
                <h4>Total Time of Activity</h4>
                <br />
                <p>All users activity time on the court</p>
                <br />
                <span>
                  <output
                    >{{ getFormattedTime(getBookingsOverview.usage_time) }}
                  </output>
                  <!-- hours -->
                </span>
                <br />
              </div>
            </div>

            <div id="activity-chart">
              <div v-show="dataTime" id="chart-label">
                <div class="char-label-div">
                  <span class="color" id="activity-this-week"></span>
                  <!-- <p>Activity this {{ getActivityTimeLabel }}</p> -->
                </div>
              </div>
            </div>
            <div id="chart-activity">
              <chartActivity
                :timePeriod="dataTime"
                @totalBooked-value="totalBookedMethod"
                @totalTime-value="totalTimeMethod"
              />
            </div>
          </div>
        </div>
        <!-- /////////////////// Time chart \\\\\\\\\\\\\\\\\\\\\\ -->
        <div class="block block--time">
          <div class="block__title_first">
            <h3>Time Statistical Overview</h3>
          </div>
          <div class="box box--time">
            <div class="box__header header--time">
              <div class="header--time__left">
                <h4>Popular hours</h4>
                <br />
                <p>The most popular hours for users</p>
                <br />
                <!-- Needs to be refactored -->
                <output>{{ getBusiestHour.hour }}:00</output>
                <br />
              </div>

              <div class="header--time__right">
                <div class="char-label">
                  <span class="color-square" id="Football"></span>
                  <p>Football</p>
                </div>
                <div class="char-label">
                  <span class="color-square" id="Hockey"></span>
                  <p>Hockey</p>
                </div>

                <div class="char-label">
                  <span class="color-square" id="Fitness"></span>
                  <p>Fitness</p>
                </div>
              </div>
            </div>
            <div class="time-chart">
              <chartTime />
            </div>
          </div>
        </div>
      </div>

      <!--------- second-section ------->
      <div class="second-section">
        <div class="block__title">
          <h3>Sport Statistical Overview</h3>
        </div>
        <div class="sports-block" style="margin: 0px auto">
          <SportsOverview />
        </div>
      </div>

      <!--------- third-section ------->
      <div class="third-section">
        <div class="block__title">
          <h3>Zones Statistical Overview</h3>
        </div>
        <chartZones />
      </div>

      <!--------- fourth-section ------->

      <div class="fourth-section" style="margin: 0px auto">
        <PopularsOverview />
      </div>
    </div>
    <!-- <div v-else>
      <div class="loader"></div>
    </div> -->
  </div>
</template>

<script>
import SportsOverview from "../components/home/SportsOverview";
import PopularsOverview from "../components/home/PopularsOverview";
import chartActivity from "../components/home/ChartAcvtivity";
import chartTime from "../components/home/ChartTime";
import chartZones from "../components/home/ChartZones";

import {
  GET_ACTIVITY_PER_CATEGORY,
  GET_ACTIVE_USERS_OVERVIEW,
  GET_BOOKINGS_OVERVIEW,
  GET_BOOKINGS_PER_CATEGORY,
  GET_MOST_POPULAR_OVERVIEW,
  GET_BOOKINGS_PER_FIELD,
  GET_USER_COURTS
} from "../store/actions.type";
import { mapGetters } from "vuex";
import getFormattedTime from "../mixins/formatTime.js";
export default {
  mixins: [getFormattedTime],
  data: function() {
    return {
      dataTime: "week",
      totalBooked: 0,
      activityPraph_TotalTime: 0,
      PopularHoures: 0
    };
  },
  components: {
    SportsOverview,
    PopularsOverview,
    chartActivity,
    chartTime,

    chartZones
  },
  watch: {
    getSelectedCourt() {
      this.loadQueries();
    }
  },

  async mounted() {
    if (this.getUserCourts == null) {
      // console.log("selected court ", this.getSelectedCourt);
      await this.$store.dispatch(GET_USER_COURTS);
    }
    this.loadQueries();
  },
  computed: {
    ...mapGetters([
      "getBookingsPerCategory",
      "getSelectedCourt",
      "getBookingsOverview",
      "getBusiestHour",
      "getUserCourts"
    ])
  },

  methods: {
    async loadQueries() {
      await this.$store.dispatch(GET_BOOKINGS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.dataTime
      });
      await this.$store.dispatch(GET_ACTIVITY_PER_CATEGORY, {
        courtId: this.getSelectedCourt.id
      });
      await this.$store.dispatch(GET_BOOKINGS_PER_CATEGORY, {
        courtId: this.getSelectedCourt.id,
        time: this.dataTime
      });

      await this.$store.dispatch(GET_ACTIVE_USERS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.dataTime
      });
      await this.$store.dispatch(GET_BOOKINGS_PER_FIELD, {
        courtId: this.getSelectedCourt.id,
        time: this.dataTime
      });
      await this.$store.dispatch(GET_MOST_POPULAR_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.dataTime
      });
    },

    async handleActivityTimeSelection() {
      await this.loadQueries();
    },

    totalBookedMethod(value) {
      this.totalBooked = value;
    },
    totalTimeMethod(value) {
      this.activityPraph_TotalTime = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/utilities.scss";

.container {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.chart-containerr {
  display: flex;
  margin-top: 150px;
}

.second {
  margin-top: 250px;
}

// .body {
//   //width: 95%;
//   //margin: 0px auto 20px auto;
// }
.block__title {
  margin: 0px auto;
  width: 92%;
}
.block__title_first {
  width: 100%;
}

.block__title_first * {
  margin: 40px 74px 15px 8px;

  font-family: Montserrat-Regular;
}
.block__title * {
  margin: 40px 74px 15px 8px;

  font-family: Montserrat-Regular;
}
.box-header {
  display: flex;
}
/* /////////////// class="first-section" /////////////// */
.first-section {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
  overflow: hidden;
  align-content: space-between;
  justify-content: space-between;
  width: 92%;

  #activity-block {
    margin: 0px auto;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 3;

    #activity-box {
      display: flex;
      flex-direction: column;
      padding: 20px 0;
      #activity-header {
        height: 116px;
        padding: 40px 52px 33px 64px;
        background-color: #383838;
        font-family: Montserrat-SemiBold;
        p {
          font-size: 14px;
          opacity: 0.7;
          color: #c3c3c3;
          font-family: Montserrat-Regular;
        }

        h3 {
          font-size: 18px;
          background-color: #383838;
        }
        output {
          font-size: 30px;
          background-color: #383838;
          display: inline-block;
        }
        #activity-label1 {
          display: block;
          background: none;
          background-color: #383838;
        }
        #activity-label2 {
          margin: 0 0 0 170px;
          background-color: #383838;
        }
      }
      #activity-chart {
        margin: 60px 0 0 0;
        background-color: #383838;

        #chart-label {
          display: flex;
          flex-direction: column;
          float: right;
          margin: 10px 20px 12px 20px;

          .char-label-div {
            display: flex;
            align-items: center;
            background-color: #383838;
            .color {
              border-radius: 0;
              width: 20px;
              height: 5px;
              margin: 12px 8px 12px 0;
            }
            #activity-this-week {
              background-color: #1ef77a;
            }
            #avg-activity-week {
              background-color: #f7941e;
            }
          }
        }
      }
      #chart-activity {
        height: 300px;
        // width: 750px;
        background-color: #383838;
        //margin: 30px 0 0 30px;
      }
    }
  }
}

.block--time {
  display: flex;
  margin: 0px auto;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;

  .box--time {
    height: inherit;
    width: 100%;
  }
  .header--time {
    display: flex;
    padding: 40px 45px 0px 37px;
    background-color: #383838;
    font-family: Montserrat-SemiBold;
    .header--time__left {
      width: 300px;
      background-color: #383838;
    }
    .header--time__right {
      width: 235px;
      text-align: right;
      background-color: #383838;
    }
  }
}

@media (min-width: 768px) {
  .first-section {
    flex-flow: row wrap;
  }
  .first-section > div {
    width: 100% !important;
  }
  .first-section > .activity-block {
    order: 1;
  }
  .first-section > .block--time {
    order: 2;
  }
}

.box__header h3 {
  font-size: 18px;
}
.box__header p {
  font-size: 14px;
  opacity: 0.7;
  color: #c3c3c3;
  font-family: Montserrat-Regular;
}

.box__header output {
  font-size: 30px;
  background-color: #383838;
  display: inline-block;
}

.char-label {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  background-color: #383838;
  margin: 0 0px 12px 0;
  .color-square {
    border-radius: 0;
    width: 20px;
    height: 5px;
    margin: 0 0px 0 8px;
  }
  #Fitness {
    background-color: #eaf2ff;
  }

  #Hockey {
    background-color: #7faffc;
  }
  #Football {
    background-color: #5696fc;
  }
}

.time-chart {
  background-color: green;
  margin: 25px 10px 0 17px;
}

/* /////////////// class="second-section" /////////////// */
.sports-block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 92%;
  h3 {
    margin: 50px 20px 15px 0;
  }
}

/* /////////////// class="third-section" /////////////// */
.third-section > .box {
  height: 563px;
  width: 92%;
}

/* /////////////// class="third-section" /////////////// */
.fourth-section {
  width: 92%;
}
.loader {
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #f7941e;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  margin: auto;
  position: absolute;
  top: 10%;
  left: 10%;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
